module.exports = __webpack_public_path__ + "img/xiongan02.f5b56f63.png";